import axios from 'axios'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { countryList, countryDelete, countryStatusChange, logOutApi } from '../../../Context/api';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UseCountry = () => {
    const [countryData, setCountryData] = useState([])
    const [countryId, setCountryId] = useState('')
    const [filter, setFilter] = useState({
        status: 'true',
        country: ''
    })
    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const [spinner, setSpinner] = useState(false)
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    useEffect(() => {
        countryListData();
        setSpinner(true)
    }, [page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: filter.status === 'true',
            searchText: filter.country,
            page: page,
            count: PER_PAGE
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data)
                setCount(resp.data.totalCount)
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setCountryData([])
                setSpinner(false)
                if (page > 1) {
                    setPage(page - 1)
                }
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const deleteCountry = () => {
        axios.post(countryDelete(), { id: countryId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                countryListData()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const changeStatus = (item) => {
        setSpinner(true)
        axios.post(countryStatusChange(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                filter.status = item.isActive.toString()
                setSpinner(false)
                countryListData()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    return {
        setCountryId,
        setCount,
        setPage,
        deleteCountry,
        countryListData,
        changeStatus,
        handleChange,
        filter,
        count,
        page,
        countryData,
        spinner,
        PER_PAGE

    }
}

export default UseCountry